<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: 'welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>活动瞬间管理</el-breadcrumb-item>
      <el-breadcrumb-item>活动瞬间列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card>
      <!-- 搜索区域 -->
      <div class="search-wrapper">
        <div class="search-toggle" v-show="isMobile" @click="toggleSearch">
        <i :class="isSearchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        <span>{{ isSearchExpanded ? '收起筛选' : '展开筛选' }}</span>
      </div>
      <div class="search-content" :class="{ 'search-content-mobile': isMobile }" v-show="!isMobile || isSearchExpanded">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-input 
                placeholder="请输入活动标题" 
                v-model="searchQuery.title_cn" 
                clearable 
                @clear="fetchEvents()" 
                size="medium">
                <el-button slot="append" icon="el-icon-search" @click="fetchEvents()"></el-button>
              </el-input>
            </el-col>
            <el-col :span="4">
              <el-select v-model="searchQuery.status" placeholder="活动状态" @change="fetchEvents" size="medium">
                <el-option :value="0" label="即将开始"></el-option>
                <el-option :value="1" label="进行中"></el-option>
                <el-option :value="2" label="已结束"></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-button type="default" @click="resetSearch" size="medium">重置</el-button>
              <el-button type="primary" @click="createEvent" size="medium" plain>创建活动瞬间</el-button>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 活动列表 -->
      <div class="table-scroll-wrapper">
        <el-table :data="eventList" style="width: 100%" border stripe>
        <el-table-column label="#" type="index" width="50" align="center"></el-table-column>
        <el-table-column label="活动名称" prop="title_cn" align="center"></el-table-column>
        <el-table-column label="副标题" prop="sub_title_cn" align="center"></el-table-column>
        <el-table-column label="封面图" width="180" align="center">
          <template slot-scope="scope">
            <el-image 
              class="cover-image" 
              :src="`${imageURL}${scope.row.cover_image_cn}`" 
              :preview-src-list="[`${imageURL}${scope.row.cover_image_cn}`]"
              fit="cover">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="活动时间" width="180" align="center">
          <template slot-scope="scope">
            {{ scope.row.event_time }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button 
              type="primary" 
              size="medium" 
              @click="viewEvent(scope.row.event_id)">
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="onSizeChange"
          @current-change="onPageChange"
          :current-page="pageNum"
          :page-sizes="[1, 2, 5, 10]"
          :page-size="pageSize"
          :layout="isMobile ? 'total, sizes, prev, pager, next' : 'total, sizes, prev, pager, next, jumper'"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { IMAGE_URL } from '@/utils/urls'
import filterMixin from '@/utils/filter.js'

export default {
  name: 'Events',
  mixins: [filterMixin],
  data() {
    return {
      isSearchExpanded: false,
      isMobile: false,
      imageURL: IMAGE_URL,
      eventList: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      searchQuery: {
        status: null,
        title_cn: ''
      },
      statusInfo: {
        0: { type: 'warning', text: '即将开始' },
        1: { type: 'success', text: '进行中' },
        2: { type: 'info', text: '已结束' }
      },
      sessionKey: 'EventsListSearch',
      filterFetchMethod: 'fetchEvents'
    }
  },
  created() {
    this.fetchEvents()
    this.checkIsMobile()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    fetchEvents() {
      this.$http({
        method: 'get',
        url: 'events/events',
        params: {
          ...this.searchQuery,
          page: this.pageNum,
          size: this.pageSize
        }
      }).then(res => {
        if (!res.success) return this.$message.error(res.message)
        this.eventList = res.data
        this.total = res.total
      }).catch(err => {
        this.$message.error(err.response?.data?.message || '获取活动列表失败')
      })
    },

    resetSearch() {
      this.searchQuery = { title_cn: '', status: null }
      this.pageNum = 1
      this.pageSize = 10
      sessionStorage.removeItem(this.sessionKey)
      this.fetchEvents()
    },

    onSizeChange(newSize) {
      this.pageSize = newSize
      this.fetchEvents()
    },

    onPageChange(newPage) {
      this.pageNum = newPage
      this.fetchEvents()
    },

    viewEvent(id) {
      this.$router.push(`/admin/event/details/${id}`)
    },

    createEvent() {
      this.$router.push('/admin/event/create')
    },

    getStatusType(status) {
      return this.statusInfo[status]?.type || 'info'
    },

    getStatusText(status) {
      return this.statusInfo[status]?.text || '未知'
    },

    toggleSearch() {
      this.isSearchExpanded = !this.isSearchExpanded
    },

    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768
    },

    handleResize() {
      const wasMobile = this.isMobile
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile && wasMobile) {
        this.isSearchExpanded = false
      }
    }
  }
}
</script>

<style scoped>
.el-card {
  margin-top: 15px;
}

.table-scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 15px;
}

.table-scroll-wrapper .el-table {
  min-width: 100%;
}

.pagination-wrapper {
  margin-top: 15px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
}

.pagination-wrapper .el-pagination {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  padding: 10px 0;
  min-width: max-content;
}

.cover-image {
  width: 150px;
  height: 80px;
  border-radius: 5px;
}

.search-wrapper {
  margin-bottom: 10px;
}

.search-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: color 0.3s;
}

.search-toggle:hover {
  color: #409eff;
}

.search-toggle i {
  font-size: 14px;
}

.search-content {
  padding-top: 10px;
}

@media (max-width: 768px) {
  .el-card {
    margin-top: 10px;
    padding: 10px;
  }

  .table-scroll-wrapper {
    margin-top: 10px;
  }

  .table-scroll-wrapper .el-table {
    font-size: 11px;
  }

  .table-scroll-wrapper .el-table th,
  .table-scroll-wrapper .el-table td {
    padding: 8px 5px !important;
  }

  .table-scroll-wrapper .el-button--small {
    font-size: 11px;
  }

  .pagination-wrapper {
    margin-top: 10px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-x;
  }

  .pagination-wrapper .el-pagination {
    font-size: 10px;
    justify-content: flex-start;
    min-width: max-content;
  }

  .pagination-wrapper .btn-prev,
  .pagination-wrapper .btn-next {
    width: 26px;
    height: 26px;
    line-height: 26px;
    font-size: 11px;
    padding: 0;
  }

  .pagination-wrapper .el-pager li {
    padding: 0 2px;
    min-width: 22px;
    height: 26px;
    line-height: 26px;
    font-size: 10px;
  }

  .pagination-wrapper .el-pagination__total {
    font-size: 10px;
    margin-right: 8px;
  }

  .pagination-wrapper .el-pagination__sizes {
    margin-right: 8px;
  }

  .pagination-wrapper .el-pagination__sizes .el-input {
    width: 60px;
  }

  .pagination-wrapper .el-pagination__sizes .el-input__inner {
    height: 24px;
    font-size: 10px;
    padding: 0 5px;
  }

  .search-content-mobile .el-row {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .search-content-mobile .el-row .el-col {
    width: 100% !important;
    margin-bottom: 5px;
  }

  .search-content-mobile .el-input,
  .search-content-mobile .el-select {
    width: 100%;
  }

  .search-toggle {
    padding: 10px 0;
    font-size: 13px;
  }

  .cover-image {
    width: 100px;
    height: 50px;
  }
}
</style>
